module.exports = __webpack_public_path__ + "media/assets/socials/fb-e5bf4efe5e421341b81d1c102a296273.svg";